var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckRectChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14.8333,
    height: 14.8333,
    viewBox: "0 0 14.8333 14.8333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.75 7.41667L6.43979 8.93748C6.72746 9.19638 7.17439 9.15673 7.412 8.85124L10.0833 5.41667M11.4167 0.75H3.41667C1.94391 0.75 0.75 1.94391 0.75 3.41667V11.4167C0.75 12.8894 1.94391 14.0833 3.41667 14.0833H11.4167C12.8894 14.0833 14.0833 12.8894 14.0833 11.4167V3.41667C14.0833 1.94391 12.8894 0.75 11.4167 0.75Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRectChecked);
export default __webpack_public_path__ + "static/media/check-rect-checked.9e09b2aa75eabb5b6a81b75316396334.svg";
export { ForwardRef as ReactComponent };